var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChaseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 21",
    style: {
      enableBackground: "new 0 0 28 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,19.2V1.8c0-0.7,0.4-1.3,1-1.6C1.6-0.1,2.4,0,2.9,0.4l9.4,7.8V1.8c0-0.7,0.4-1.3,1-1.6 c0.6-0.3,1.3-0.2,1.9,0.2l9.4,7.8V1.8c0-1,0.8-1.7,1.8-1.7S28,0.8,28,1.8v17.5c0,1-0.8,1.7-1.8,1.7s-1.8-0.8-1.8-1.7v-6.5l-9.4,7.8 c-0.5,0.4-1.3,0.5-1.9,0.2c-0.6-0.3-1-0.9-1-1.6v-6.5l-9.4,7.8C2.3,21,1.6,21.1,1,20.8C0.4,20.5,0,19.9,0,19.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaseIcon);
export default __webpack_public_path__ + "static/media/Chase_Icon.6383d8f6e5214e595f79e96f4386fcda.svg";
export { ForwardRef as ReactComponent };